module.exports = __webpack_public_path__ + "static/media/Add SIKI Coins 2.536f4557.svg";